import { render, staticRenderFns } from "./groupWelcomeResourcesDetail.vue?vue&type=template&id=08d7c268&"
import script from "./groupWelcomeResourcesDetail.vue?vue&type=script&lang=js&"
export * from "./groupWelcomeResourcesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d7c268')) {
      api.createRecord('08d7c268', component.options)
    } else {
      api.reload('08d7c268', component.options)
    }
    module.hot.accept("./groupWelcomeResourcesDetail.vue?vue&type=template&id=08d7c268&", function () {
      api.rerender('08d7c268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/groupWelcomeResources/groupWelcomeResourcesDetail.vue"
export default component.exports